<template>
    <div class="mt-4">
        <div class="d-flex flex-column gap-3">

            <div v-if="activeTab === 'impressions'">
                <div v-if=" !allImpressionsAndClicksEmpty">
                    <div v-if="!merchantCenterImpressionsAndClicksEmpty">
                        <LineChartWrapper
                            :series="lineChartMappingImpressions"
                            :title="__('statistics.impressions_products')"
                            icon="fas fa-2x fa-chart-bar">
                        </LineChartWrapper>

                        <LineChartWrapper
                            class="mt-20"
                            :series="lineChartMappingClicks"
                            :title="__('statistics.clicks_products')"
                            icon="fas fa-2x fa-mouse-pointer">
                        </LineChartWrapper>
                    </div>

                    <div v-if="!businessPerformanceEmpty">
                        <LineChartWrapper
                            class="mt-20"
                            :series="gmbSeries[GoogleBusinessMetrics.WEBSITE_CLICKS]"
                            :title="__('statistics.' + GoogleBusinessMetrics.WEBSITE_CLICKS)"
                            icon="fas fa-2x fa-mouse-pointer">
                        </LineChartWrapper>

                        <LineChartWrapper
                            class="mt-20"
                            :series="gmbSeries[GoogleBusinessMetrics.IMPRESSIONS_MOBILE_SEARCH]"
                            :title="__('statistics.' + GoogleBusinessMetrics.IMPRESSIONS_MOBILE_SEARCH)"
                            icon="fas fa-2x fa-chart-bar">
                        </LineChartWrapper>

                        <LineChartWrapper
                            class="mt-20"
                            :series="gmbSeries[GoogleBusinessMetrics.IMPRESSIONS_DESKTOP_SEARCH]"
                            :title="__('statistics.' + GoogleBusinessMetrics.IMPRESSIONS_DESKTOP_SEARCH)"
                            icon="fas fa-2x fa-chart-bar">
                        </LineChartWrapper>

                        <LineChartWrapper
                            class="mt-20"
                            :series="gmbSeries[GoogleBusinessMetrics.IMPRESSIONS_MOBILE_MAPS]"
                            :title="__('statistics.' +GoogleBusinessMetrics.IMPRESSIONS_MOBILE_MAPS )"
                            icon="fas fa-2x fa-chart-bar">
                        </LineChartWrapper>

                        <LineChartWrapper
                            class="mt-20"
                            :series="gmbSeries[GoogleBusinessMetrics.IMPRESSIONS_DESKTOP_MAPS]"
                            :title="__('statistics.' + GoogleBusinessMetrics.IMPRESSIONS_DESKTOP_MAPS)"
                            icon="fas fa-2x fa-chart-bar">
                        </LineChartWrapper>

                        <LineChartWrapper
                            class="mt-20"
                            :series="gmbSeries[GoogleBusinessMetrics.CALL_CLICKS]"
                            :title="__('statistics.' + GoogleBusinessMetrics.CALL_CLICKS)"
                            icon="fas fa-2x fa-mouse-pointer">
                        </LineChartWrapper>
                    </div>
                    <p v-else class="text-center text-xl mt-10">{{ __('statistics.no_gmb_metrics') }}</p>

                </div>
                <p v-else class="text-center text-xl mt-10">{{ __('statistics.impressions_empty_for_filters') }}</p>
            </div>

            <div v-if="activeTab === 'productBrand'" class="card card-body">
                <div v-for="(storeStatistic, storeUuid) in statistics.MC">
                    <stats-popular
                        v-if="storeStatistic.bestProducts.length > 0"
                        :statistics="storeStatistic.bestProducts"
                        :store-name="$page.props.store.attributes.name"
                        :key="storeUuid+'product'"
                        article/>
                    <div v-else class="px-2 py-6 shadow-xs rounded">
                        <p class="text-center text-xl">{{ __('statistics.product_stats_empty_for_date') }}</p>
                    </div>
                    <stats-popular
                        class="mt-20"
                        v-if="storeStatistic.bestBrands.length > 0"
                        :statistics="storeStatistic.bestBrands"
                        :store-name="$page.props.store.attributes.name"
                        :key="storeUuid+'brand'"
                        brand/>
                    <div v-else class="px-2 py-6 shadow-xs rounded">
                        <p class="text-center text-xl">{{ __('statistics.brand_stats_empty_for_date') }}</p>
                    </div>
                </div>
            </div>

            <div v-if="activeTab === 'categories'" class="card card-body">
                <div v-for="(storeStatistic, storeUuid) in statistics.MC">
                    <stats-popular
                        v-if="storeStatistic.bestCategories.length > 0"
                        :statistics="storeStatistic.bestCategories"
                        :store-name="$page.props.store.attributes.name"
                        :key="storeUuid+'category'"
                        category/>
                    <div v-else class="px-2 py-6 shadow-xs rounded">
                        <p class="text-center text-xl">{{ __('statistics.impressions_empty_for_date') }}</p>
                    </div>
                </div>
            </div>

            <div v-if="activeTab === 'productBestseller'" class="card card-body">
                <div v-for="(storeStatistic, storeUuid) in statistics.MC">
                    <stats-best-seller
                        v-if="storeStatistic.bestSellerProducts.length > 0"
                        :statistics="storeStatistic.bestSellerProducts"
                        :store-name="$page.props.store.attributes.name"
                        :key="storeUuid+'brand'"
                        product
                    />
                    <div v-else class="px-2 py-6 shadow-xs rounded">
                        <p class="text-center text-xl">{{ __('statistics.impressions_empty_for_date') }}</p>
                    </div>
                </div>
            </div>

            <div v-if="activeTab === 'brandBestseller'" class="card card-body">
                <div v-for="(storeStatistic, storeUuid) in statistics.MC">
                    <stats-best-seller
                        v-if="storeStatistic.bestSellerBrands.length > 0"
                        :statistics="storeStatistic.bestSellerBrands"
                        :store-name="$page.props.store.attributes.name"
                        :key="storeUuid+'brand'"
                        brand
                    />
                    <div v-else class="px-2 py-6 shadow-xs rounded">
                        <p class="text-center text-xl">{{ __('statistics.impressions_empty_for_date') }}</p>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import StatsPopular from '@pages/Stats/Widgets/StatsPopular.vue';
import StatsBestSeller from '@pages/Stats/Widgets/StatsBestSeller.vue';
import LineChart from '@pages/Stats/Widgets/LineChart.vue';
import Toolbar from '@components/Toolbar.vue';
import FilterDateRange from '@components/Stats/Filters/FilterDateRange.vue';
import FilterBar from '@components/Stats/FilterBar.vue';
import Card from '@components/Cards/Card.vue';
import StatisticsLayout from '@layouts/Statistics/StatisticsLayout.vue';
import {GoogleBusinessMetrics} from '@generated/googleBusinessMetrics';
import LineChartWrapper from '@components/Stats/Components/LineChartWrapper.vue';

export default {
    layout: StatisticsLayout,

    components: {
        LineChartWrapper,
        Card,
        FilterBar,
        FilterDateRange,
        Toolbar,
        StatsBestSeller,
        StatsPopular,
        LineChart,
    },

    props: {
        statistics: Object,
        mcSeriesImpressionsClicks: Object,
        gmbSeries: Object,
        store: Object,
        initTab: String,
    },

    data() {
        return {
            activeTab: this.initTab,
        };
    },

    watch: {
        initTab(newValue, oldValue) {
            this.activeTab = newValue;
        },
    },

    computed: {
        GoogleBusinessMetrics() {
            return GoogleBusinessMetrics;
        },

        lineChartMappingImpressions() {
            return Object.entries(this.mcSeriesImpressionsClicks).map(([storeId, storeData]) => {
                return {
                    data: storeData[1].data.map((item) => ({
                        x: item.x,
                        y: item.y,
                    })),
                    name: this.__('statistics.impressions'),
                    total: storeData[1].total,
                };
            });
        },

        lineChartMappingClicks() {
            return Object.entries(this.mcSeriesImpressionsClicks).map(([storeId, storeData]) => {
                return {
                    data: storeData[0].data.map((item) => ({
                            x: item.x,
                            y: item.y,
                        }),
                    ),
                    name: this.__('statistics.clicks'),
                    total: storeData[0].total,
                };
            });
        },

        merchantCenterImpressionsAndClicksEmpty() {
            return Object.values(this.mcSeriesImpressionsClicks).every(storeData => {
                return storeData[0].total === 0 && storeData[1].total === 0;
            });
        },

        businessPerformanceEmpty() {
            return Object.values(this.gmbSeries).every(singleData => {
                return singleData[0].total === 0;
            });
        },

        allImpressionsAndClicksEmpty() {
            return this.businessPerformanceEmpty && this.merchantCenterImpressionsAndClicksEmpty;
        },
    },
};
</script>
